import styled  from 'styled-components';
import PropTypes from 'prop-types';

const ClaroButton = styled.button`
&& {
  ${props =>
    (props
      ? `
      ${props ? 
        `
        float: ${props.float === undefined ? 'none' : props.float};
        color: ${props.color === undefined ? '#ffffff' : props.color};
        text-align: center;
        border: ${props.border === undefined ? 'none' : props.border};
        border-color: ${props.borderColor === undefined ? '#ffffff' : props.borderColor};
        width: ${props.width === undefined ? '11.466666666666667VW' : props.width};
        height: ${props.height === undefined ? '11.466666666666667VW' : props.height};
        background-color: ${props.backgroundColor === undefined ? '#000' : props.backgroundColor} ;
        border-radius: ${props.borderRadiusClaro === undefined ? '50em' : props.borderRadiusClaro} ;
        line-height: ${props.lineHeight === undefined ? '11VW' : props.lineHeight} ;
        margin: ${props.margin === undefined ? 'opx' : props.margin} ;
        font-size: ${props.fontSize === undefined ? '16px' : props.fontSize};
        font-weight: 'bold';
        font-family: ${props.fontFamily === undefined ? 'Amx-Bold' : props.fontFamily} !important;
        padding: ${props.padding === undefined ? '6px' : props.padding};
        white-space : ${props.white_space === undefined ? 'normal': props.white_space};
        word-wrap: ${props.word_wrap === undefined ? 'break-word': props.word_wrap};
        line-height: ${props.lineHeightClaro === undefined ? '11VW' : props.lineHeightClaro};
        ${props.favoritos && props.disabled ?
          `
            background-color: #D6D6D6
            border-color: #fafafa;
            color: #848484;
          `
          :
        props.disabled && !props.cancelStylesDisabled ?
          `
            background-color:${props.isClaroPartner? '#E6E6E6' : !props.isClaroPartner && props.isContainerTelcel ? '#d0d0d0' : '#FAFAFA '};
            opacity:1;
            border-color: #fafafa;
            color: ${props.isClaroPartner? '#b2b2b2!important' : !props.isClaroPartner && props.isContainerTelcel ? '#595959!important' : '#ddd!important'};
          `
          :
          `
            background-color:${props.backgroundColor};
            border-color: ${props.borderColor};
            color: ${props.color};
          `};
        `
        :
        ''};
      `
      : '')
    };
    }`;

ClaroButton.propTypes = {
  color: PropTypes.string,
  background: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  hoverColor: PropTypes.string,
  hoverBackground: PropTypes.string
}

ClaroButton.defaultProps = {
  height:'50px',
  borderRadius:'5px',
  width:'100%',
};

export default ClaroButton;